import * as React from 'react'
import { Navigate, Route, RouteProps } from 'react-router'
import { DelarStatus } from '../enum/delar-status.enum'
import { SecurityManager } from './security.manager'


const SecureRoute: React.FC<RouteProps> = props => {
    const loggedIn = SecurityManager.loggedIn()
    const verificationStatus = SecurityManager.getVerified()

    console.log(`============>${loggedIn}`)
    console.log(`============>${verificationStatus}`)

    return <Route {...props} />

    if (loggedIn && verificationStatus == DelarStatus.Verified) {
        return <Route {...props} />
    } else if (loggedIn && verificationStatus == DelarStatus.Pending) {
        const redirectUrl = '/'
        return <Navigate to={redirectUrl} />
    } else if (loggedIn && verificationStatus == DelarStatus.NotInit) {
        const redirectUrl = '/on-board/detail/1'
        return <Navigate to={redirectUrl} />
    } else if (loggedIn && verificationStatus == DelarStatus.Rejected) {
        const redirectUrl = '/verification-rejected'
        return <Navigate to={redirectUrl} />
    }
    else {
        let redirectUrl = '/on-board'
        const language = SecurityManager.getLanguage()
        if (language.length > 0) {
            redirectUrl = '/on-board/register'
        }
        
        return <Navigate to={redirectUrl} />
    }
}

export default SecureRoute